import { Link } from "react-router-dom";
import EmptyCart from "../assets/empty_cart.svg";
import CartItem from "../components/ui/CartItem";

export default function Cart({ cart, changeQuantity, removeItem }) {
  const subTotal = () => {
    let price = 0;
    cart.forEach((item) => {
      price += +(item.salePrice || item.originalPrice) * item.quantity;
    });
    return price;
  };

  return (
    <div id="cart__body">
      <main id="cart__main">
        <section id="cart">
          <div className="books__container">
            <div className="row">
              <div className="book__selected--top">
                <h2 className="cart__title">Cart</h2>
              </div>
              <div className="cart">
                <div className="cart__header">
                  <span className="cart__book">Book</span>
                  <span className="cart__quantity">Quantity</span>
                  <span className="cart__total">Total</span>
                </div>
                {cart.length > 0 ? (
                  <div className="cart__body">
                    {cart.map((book) => (
                      <CartItem
                        key={book.id}
                        book={book}
                        changeQuantity={changeQuantity}
                        removeItem={removeItem}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="cart__empty">
                    <img src={EmptyCart} alt="" className="cart__empty--img" />
                    <h2>You don't have any books in your cart!</h2>
                    <Link to="/books">
                      <button className="btn">Browse Books</button>
                    </Link>
                  </div>
                )}
                {cart.length > 0 && (
                  <div className="total">
                    <div className="total__item total__sub-total">
                      <span>Subtotal</span>
                      <span>${subTotal().toFixed(2)}</span>
                    </div>
                    <div className="total__item total__tax">
                      <span>Tax</span>
                      <span>${(subTotal() * 0.07).toFixed(2)}</span>
                    </div>
                    <div className="total__item total__price">
                      <span>Total</span>
                      <span>${(subTotal() * 1.07).toFixed(2)}</span>
                    </div>
                    <button
                      onClick={() => alert("Feature not yet implemented!")}
                      className="btn btn__checkout no-cursor"
                    >
                      Proceed to Checkout
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
